import { NgModule } from '@angular/core';
import { NkToolbarComponent } from './toolbar.component';
@NgModule({
  imports: [
    NkToolbarComponent
  ],
  exports: [NkToolbarComponent],
})
export class NkToolbarModule {}
